var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Controls"},[_c('van-rate',{staticClass:"rateBox",attrs:{"readonly":""},model:{value:(_vm.value.value),callback:function ($$v) {_vm.$set(_vm.value, "value", $$v)},expression:"value.value"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }